import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

export interface PermitDetailsSectionProps {
  permitType: string;
  submittedDate?: string | null;
  approvedDate?: string | null;
  expiryDate?: string | null;
  issuingAuthority: string;
}

interface DetailItemProps {
  label: string;
  value: string;
}

const DetailItem: React.FC<DetailItemProps> = ({ label, value }) => (
  <Box>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1" fontWeight={500} sx={{ mt: 0.5 }}>
      {value}
    </Typography>
  </Box>
);

export const PermitDetailsSection: React.FC<PermitDetailsSectionProps> = ({
  permitType,
  submittedDate,
  approvedDate,
  expiryDate,
  issuingAuthority,
}) => {
  return (
    <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Permit Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <DetailItem label="Permit Type" value={permitType} />
        </Grid>
        {submittedDate && (
          <Grid item xs={12} sm={6}>
            <DetailItem label="Submitted Date" value={new Date(submittedDate).toLocaleDateString()} />
          </Grid>
        )}
        {approvedDate && (
          <Grid item xs={12} sm={6}>
            <DetailItem label="Approved Date" value={new Date(approvedDate).toLocaleDateString()} />
          </Grid>
        )}
        {expiryDate && (
          <Grid item xs={12} sm={6}>
            <DetailItem label="Expiry Date" value={new Date(expiryDate).toLocaleDateString()} />
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <DetailItem label="Issuing Authority" value={issuingAuthority} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PermitDetailsSection;
